// import _ from "lodash";
import Vue from "vue";
import Router from "vue-router";

// Components
import Home from "../components/Home.vue";
import Posts from "../components/Post/Posts.vue";
import Post from "../components/Post/Post.vue";
import Materials from "../components/Material/Materials.vue";
import Material from "../components/Material/Material.vue";
import Page from "../components/Page/Page.vue";

Vue.use(Router);

const router = new Router({
  routes: [{
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/materials",
      name: "Materials",
      component: Materials
    },
    {
      // Assuming you're using the default permalink structure for posts
      path: "/material/:postSlug",
      name: "Material",
      component: Material
    },
    {
      // Assuming you're using the default permalink structure for posts
      path: "/material/(.*)/:postSlug",
      // name: "Material",
      component: Material
    },
    {
      path: "/blog",
      name: "Posts",
      component: Posts
    },
    {
      // Assuming you're using the default permalink structure for posts
      path: "/:year/:month/:day/:postSlug",
      name: "Post",
      component: Post
    },
    {
      path: "/:pageSlug(.*)",
      name: "Page",
      component: Page
    },
    {
      path: '*',
      redirect: {
        name: 'Material',
        params: {
          postSlug: "404-not-found"
        }
      }
    }
  ],
  mode: "history",
  base: "",

  // Prevents window from scrolling back to top
  // when navigating between components/views
  scrollBehavior(to, from, savedPosition) {

    // var options = {
    //   easing: 'ease-in',
    // };

    // var cancelScroll = this.$scrollTo("'#app'", 500, options)
    // return goTo(scrollTo, {
    //   duration: 500
    // })

    // close header menu
    router.app.$store.dispatch("closeHeaderMenu");

    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});

router.afterEach((to, from) => {
  // Add a body class specific to the route we're viewing
  let body = document.querySelector("body");
  let bodyClasses = body.className.split(" ");

  if (bodyClasses.length > 0) {
    const newBodyClasses = bodyClasses.filter(theClass =>
      theClass.startsWith("vue--page--")
    );
  }

  // const slug = _.isEmpty(to.params.postSlug) ?
  //   to.params.pageSlug :
  //   to.params.postSlug;
  //   if(slug){
  //     body.classList.add(slug , "vue--page--" + slug);
  //   }
});

export default router;